import React, { useEffect } from "react"
import { useGamesContext } from "contexts/GamesContext"
import { AppEmbedLayoutUI } from "./AppEmbedLayout.ui"

/**
 * Injects current game metadata into the global window object.
 * Useful for Mobile App WebViews to know which game is being played.
 */
const MetadataInjector = () => {
  const { game, gameSessionData, exercisesContent, exerciseContentIndex } =
    useGamesContext()

  useEffect(() => {
    if (game || gameSessionData) {
      const metadata = {
        game,
        session: gameSessionData,
      }
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            event: "onGameLoaded",
            metadata,
          })
        )
      }
    }
  }, [game?.gameId, gameSessionData?.gameSessionId])

  useEffect(() => {
    const currentExercise = exercisesContent[exerciseContentIndex]
    if (
      window.ReactNativeWebView &&
      currentExercise?.exerciseId > 0 &&
      currentExercise?.moduleActivityId > 0
    ) {
      const metadata = {
        exerciseContentIndex: exerciseContentIndex,
        exercisesContent,
        exerciseId: currentExercise?.exerciseId,
        moduleActivityId: currentExercise?.moduleActivityId,
      }
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          event: "onExerciseContentLoad",
          metadata,
        })
      )
    }
  }, [exercisesContent, exerciseContentIndex])

  return null
}

export const AppEmbedLayoutView = () => {
  return (
    <AppEmbedLayoutUI>
      <MetadataInjector />
    </AppEmbedLayoutUI>
  )
}
